import { AccordionButton, useAccordionItemState } from "@chakra-ui/react";
import React from "react";
import { InfoArrow } from "~misc/icons";

const FunnelShowMoreHeader = ({ alwaysActived = false }) => {
  const { isOpen } = useAccordionItemState();

  return (
    <AccordionButton 
      className={`funnel-accordion-header show-more-header ${isOpen ? 'active' : ''}`}
    >
      {!alwaysActived && (
        <>
          {isOpen ? "Exibir menos" : "Exibir mais"}
          <InfoArrow className="icon" fill="#CFCFDF" />
        </>
      )}
    </AccordionButton>
  );
};

export default FunnelShowMoreHeader;